import React, { useEffect, useState } from 'react';
import SplitPane, { Pane } from 'split-pane-react';
import 'split-pane-react/esm/themes/default.css';
import authService from '../../../services/auth/auth.service';
import ContractorCardTabs from "./tabs"
import { useParams } from 'react-router-dom';
import ContractorCardFormData from './formdata';
import $ from 'jquery'; 

export class ContractorData{
  id?: number  
  row_no?: number
  shortname : string =''
  state_id? : number
  contractor_state: string = ''
  nip: string = ''
  regon: string = ''
  country: string = ''
  city: string = ''
  street: string = ''
  province: string = ''
  name: string = ''
  webpage: string = ''
  mail: string = ''
  phone: string = ''
  fax: string = ''
  contractortype_id: string = ''
  contractor_type: string = ''
  krs: string = ''
  postcode: string = ''
  isperson?: number
  isperson_txt: string = ''
  contactdate: number = 0
  group_names: string = ''
  group_names_array:string[] = []
  labels: string = ''
  labels_array: string[] = []
  contractortradedef_id?: number
  trade_name: string = ''
  investmentinventorystate_id?:number
  iis_name: string = ''
  cor_country: string = ''
  cor_city: string = ''
  cor_street: string = ''
  cor_province: string = ''
  cor_postcode: string = ''
  group_ids: string = ''
  sendmail?:number
  archival?:number
  newmstate_id?:number
  contractor_newmstate: string = ''
  classifications: string = ''
  classifications_array: string[] = []
  unsub_eml?:  number
  unsub_tel?: number
  gtu: string = ''
  gtu_array : string[]=[]
  created? : Date
  modified? : Date
}

function ContractorCard () {
  const [sizes, setSizes] = useState([50, 50]);

 

  const [gridsHeight, setGridsHeight] = useState(200);
 
  const LOCAL_SPLITTER = authService.getCurrentUser()?.shrt + '_crm-' + 'contractorcard-splitter'


  
  useEffect(()=>{
    // your job here
   var data = localStorage.getItem(LOCAL_SPLITTER)
   if (data){
      const arr = JSON.parse(data) as number[]
      setSizes(arr);

   }

   

    window.addEventListener('error', e => {
        if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
            const resizeObserverErrDiv = document.getElementById(
                'webpack-dev-server-client-overlay-div'
            );
            const resizeObserverErr = document.getElementById(
                'webpack-dev-server-client-overlay'
            );
            if (resizeObserverErr) {
                resizeObserverErr.setAttribute('style', 'display: none');
            }
            if (resizeObserverErrDiv) {
                resizeObserverErrDiv.setAttribute('style', 'display: none');
            }
        }
    });

   

  }, [])

  const changeSplitter =  (sizes: number[]) => {
    localStorage.setItem(LOCAL_SPLITTER, JSON.stringify(sizes))
    setSizes(sizes)
   var hh = $("#card-bottom-panel").height()
    $("#card-contact-grid").height(hh as number -150)
    $("#card-note-grid").height(hh as number -150)
    $("#card-change-grid").height(hh as number -150)

  } 

  const layoutCSS = {
    height: '100%',
    //display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    
  };

  const params = useParams();
  const param_id = params.id
  var contractor_id = -1
  if (param_id){
    var tmp_id = parseInt(param_id)
    if (!Number.isNaN(tmp_id)){
      contractor_id = tmp_id
    }

  }
  

  return (
    <div className="splitWrapper" >
      <SplitPane
        split='horizontal'
        sizes={sizes}
        onChange={changeSplitter}
        sashRender={function (index: number, active: boolean): React.ReactNode {
          return ""
          //throw new Error('Function not implemented.');
        } }              >
        <Pane minSize={50}>
          <div style={{ ...layoutCSS, overflow:"auto"}}>
              <ContractorCardFormData contractor_id={contractor_id}></ContractorCardFormData>
          </div>
        </Pane>
        <div id="card-bottom-panel" style={{ ...layoutCSS, overflow:"auto" }}>
            <ContractorCardTabs  contractor_id={contractor_id}></ContractorCardTabs>

        </div>
       
      </SplitPane>
    </div>
  );
};

export default ContractorCard